import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import TrailerTireLine from './TrailerTireLine'

const BOTSearchTrailerTiresResult = ({ viewModel }) =>
  <Wrapper>
    {
      viewModel.map(data =>
        <TrailerTireLine key={ data.tireLineName } { ...data } />
      )
    }
  </Wrapper>

export default BOTSearchTrailerTiresResult

BOTSearchTrailerTiresResult.propTypes = {
  viewModel: PropTypes.arrayOf(PropTypes.shape({
    tireLineName: PropTypes.string
  }))
}

const Wrapper = styled.div`
  margin: 25px 0 40px;
  ${Media.desktop`
    margin: 0 auto 80px;
    padding: 0 55px;
  `}
`
